import { render, staticRenderFns } from "./SearchFormSpacer.vue?vue&type=template&id=0f87e208&scoped=true&"
import script from "./SearchFormSpacer.vue?vue&type=script&lang=js&"
export * from "./SearchFormSpacer.vue?vue&type=script&lang=js&"
import style0 from "./SearchFormSpacer.vue?vue&type=style&index=0&id=0f87e208&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f87e208",
  null
  
)

export default component.exports